import { Field, FieldProps } from 'formik';

import Checkbox from '../ui/Checkbox';

type CheckboxFormikProps = {
  name: string;
  children: any;
};

const CheckboxFormik = (props: CheckboxFormikProps) => {
  return (
    <Field name={props.name}>
      {(field: FieldProps) => (
        <div className="space-y-0">
          <Checkbox
            name={props.name}
            value={field.field.value}
            onChange={(newValue) => field.form.setFieldValue(props.name, newValue)}
            onBlur={field.field.onBlur}
          >
            {props.children}
          </Checkbox>
          {field.form.errors[field.field.name] && field.form.touched[field.field.name] && (
            <p className="text-red-700 text-sm mt-1">{field.form.errors[field.field.name]}</p>
          )}
        </div>
      )}
    </Field>
  );
};

export default CheckboxFormik;
